import Filter from "components/ui/Filter";
import Spinner from "components/ui/Spinner";
import StepNav from "components/ui/StepNav";
import StepTitle from "components/ui/StepTitle";
import { useEffect, useState } from "react";
import { categories } from "types/realization";
import { useAuth } from "context/AuthContext";
import { fetchIndicatedList } from "services/indicatedList.service";
import { IndicatedRealizacaoItem } from "types/indicated";
import RealizacaoCard from "components/ui/IndicatedCard";

const IndicatedList = () => {
  const { user } = useAuth();
  const [loadingItens, setLoadingItens] = useState(false);
  const [categories, setCategories] = useState<categories[]>([]);
  const [realizations, setRealizations] = useState<IndicatedRealizacaoItem[]>(
    []
  );
  const [filteredRealization, setFilteredRealization] = useState<
    IndicatedRealizacaoItem[]
  >([]);

  const [filter, setFilter] = useState<{
    category?: string;
    searchTerm?: string;
  }>({});

  useEffect(() => {
    fetchData();
  }, [user]);

  const fetchData = async () => {
    try {
      setLoadingItens(true);
      const data = await fetchIndicatedList();

      const items = data ? data.flatMap((item) => item.realizations) : [];

      let newCategories = data
        ? data.map((item) => {
            return {
              name: `${item.categoryName}(${item.realizations.length || 0})`,
              _id: String(item.categoryName),
            };
          })
        : [];

      newCategories.unshift({
        name: `Todas (${items.length})`,
        _id: "-1",
      });
      setCategories(newCategories as categories[]);

      setRealizations(items);
      setFilteredRealization(items);
    } catch (e) {
    } finally {
      setLoadingItens(false);
    }
  };

  const filterData = (
    data: IndicatedRealizacaoItem[],
    category?: string,
    title?: string,
  ) => {
    let filteredData = data.filter((item) => {
      const categoriaMatch =
        category && category !== "-1" ? item.categoria === category : true;

      const tituloMatch = title
        ? item.titulo.toLocaleLowerCase().includes(title)
        : true;

      return categoriaMatch && tituloMatch;
    });

    return filteredData;
  };

  useEffect(() => {
    let result = filterData(
      realizations,
      filter.category,
      filter.searchTerm?.toLocaleLowerCase(),
    );

    setFilteredRealization(result);
  }, [filter, realizations]);

  return (
    <>
      {loadingItens ? (
        <div className="flex items-start justify-center w-full h-screen">
          <div className="flex flex-col">
            <Spinner />
            <span className="text-center text-blue-bb">Carregando...</span>
          </div>
        </div>
      ) : (
        <>
          <StepNav currentStep={4} activeSubStep={3} />
          <StepTitle
            title={"Lista de Indicados"}
            description={`Conheça os 5 funcionários que poderão receber o prêmio individual, caso a iniciativa seja premiada na última etapa de votação. Esses funcionários foram escolhidos, por meio de votação, pelos participantes da Realização Destaque, na etapa de inscrição do Prêmio BB 2025.`}
          />

          <div className="mb-4">
            <span className="text-sm text-red-500">
              Critério de desempate adotado: Atender aos requisitos listados na
              IN 403-item 7.7 e a pontuação alcançada pelo funcionário no Placar
              Consolidado do Conexão - (1) Dimensão Individual e (2) Dimensão
              Competências de seu Acordo de Trabalho definido para o semestre,
              nesta ordem.
            </span>
          </div>

          <div className="flex items-end justify-end mb-4">
            <div className="w-full">
              <Filter
                categories={categories}
                enableCategoryFilter={true}
                enablePrefixFilter={false}
                placeholderField={"Buscar por titulo de realizações"}
                onChange={(key, value) => {
                  setFilter((prev) => ({ ...filter, [key]: value }));
                }}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {filteredRealization
              .slice()
              .sort((a, b) => a.titulo.localeCompare(b.titulo))
              .map((item) => (
                <RealizacaoCard key={item.id_realizacao} realizacao={item} />
              ))}
          </div>
        </>
      )}
    </>
  );
};

export default IndicatedList;
